import { INamedEntity, IOption } from '../types';

/**
 * Reorder an array of INamedEntities into an options list sorted by name.
 *
 * @param items - The array of INamedEntities to reorder.
 * @returns An array of sorted IOption.
 */
export function asSortedOptions<T extends INamedEntity = INamedEntity>(items: T[]): IOption[] {
  items.sort((a, b) => {
    const nameA = (a.name as string).toLowerCase();
    const nameB = (b.name as string).toLowerCase();
    return (nameA < nameB) ? -1 : (nameA > nameB) ? 1 : 0;
  });
  return items as IOption[];
}
